module.exports = "/assets/70e9bad5223fac9a620cf24fd4dad4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QX.png
// module id = 1767
// module chunks = 0